export enum MspInProductTrialsOverlayWindowType {
  menuOverlay = 'menuOverlay',
  companiesOverlay = 'companiesOverlay',
}
